import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import axios from 'axios'
import VueCookies from 'vue3-cookies'
import VCalendar from 'v-calendar'
import 'v-calendar/style.css'
import { VueSignaturePad } from 'vue-signature-pad'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import NetworkError from './components/utils/NetworkError.vue'

loadFonts()

const app = createApp(App)
app.use(router)
app.use(store)
app.use(vuetify)
app.use(VueCookies)
app.use(VCalendar)
app.config.globalProperties.axios = axios
app.component('VueSignaturePad', VueSignaturePad)
app.component('NetworkError', NetworkError)
app.use(VueSweetalert2)
app.mount('#app')
